import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { jwtDecode } from "jwt-decode";

import { useAuth } from "contexts/AuthContext";
import UserService from "services/User.service";

const UserSettingContext = createContext();

const orgID = process.env.REACT_APP_ORGANIZATIONNAME;

export const UserSettingProvider = ({ children }) => {
  const { token } = useAuth();

  const [userState, setUserState] = useState(null);
  const [isUserLoading, setIsUserLoading] = useState(true);

  const getUser = async () => {
    try {
      setIsUserLoading(true);

      const tokenSetting = jwtDecode(token);

      const response = await UserService.getUserSetting(
        orgID,
        tokenSetting.name
      );

      const user = response.data;

      setUserState(user);

      // 可以保留當 cache / debug 用，
      // 但 UI 權限判斷不要依賴 localStorage
      localStorage.setItem(
        "is_supporter",
        String(user?.properties?.is_supporter ?? false)
      );
    } catch (error) {
      console.error("Get user setting failed:", error);

      setUserState(null);
    } finally {
      setIsUserLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      getUser();
    } else {
      setUserState(null);
      setIsUserLoading(false);
      localStorage.removeItem("is_supporter");
    }
  }, [token]);

  const isSupporter = useMemo(() => {
    return userState?.properties?.is_supporter === true;
  }, [userState]);

  const setUserContext = (user) => {
    setUserState(user);
  };

  return (
    <UserSettingContext.Provider
      value={{
        userState,
        isSupporter,
        isUserLoading,
        setUserContext,
      }}
    >
      {children}
    </UserSettingContext.Provider>
  );
};

export const useUserContext = () => {
  const context = useContext(UserSettingContext);

  if (!context) {
    throw new Error(
      "useUserContext 必須在 UserSettingProvider 中使用"
    );
  }

  return context;
};